import {
  LayoutSettingsActionTypes,
  SET_LAYOUT_SIDE_BAR_COLLAPSED,
  SET_MESSAGE_CENTER_COLLAPSED,
} from './types';
import PET_CONFIG from '../../config/pet.config';

const initialState = {
  sideBarCollapsed: true,
  sideBarCollapsedWidth: 60,
  sideBarWidth: 223,
  mainHeaderHeight: PET_CONFIG.baseLayoutSettings.mainHeaderHeight,
  messageCenterCollapsed: true,
  messageCenterWidth: 410,
};

export default function baseLayoutSettingsReducer(
  state = initialState,
  action: LayoutSettingsActionTypes
) {
  switch (action.type) {
    case SET_LAYOUT_SIDE_BAR_COLLAPSED: {
      const { collapsed } = action;
      return {
        ...state,
        sideBarCollapsed: collapsed,
      };
    }
    case SET_MESSAGE_CENTER_COLLAPSED: {
      const { collapsed } = action;
      return {
        ...state,
        messageCenterCollapsed: collapsed,
      };
    }
    default:
      return state;
  }
}
